import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { apiError } from "../lib/api";
import AuthShell from "./AuthShell";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [params] = useSearchParams();
  const isAdmin = params.get("admin") === "1";
  const backTo = isAdmin ? "/admin/login" : "/login";
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:border-[#D4AF37] focus:ring-0 transition-colors duration-200";

  return (
    <AuthShell testid="forgot-page" title="Reset Password" subtitle="We'll send you a secure reset link.">
      {sent ? (
        <div data-testid="forgot-success" className="bg-[#141414] border border-[#D4AF37]/30 rounded-2xl p-8 text-center">
          <MailCheck className="w-10 h-10 text-[#D4AF37] mx-auto mb-4" />
          <p className="text-gray-300">If an account exists for <span className="text-white">{email}</span>, a reset link is on its way.</p>
          <Link to={backTo} className="text-[#D4AF37] inline-block mt-5">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="forgot-email" type="email" required placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className={field} />
          <button data-testid="forgot-submit" disabled={loading} className="w-full py-3.5 rounded-full bg-[#D4AF37] text-black font-medium hover:bg-[#F3E5AB] transition-colors duration-300 disabled:opacity-60 flex items-center justify-center gap-2">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send Reset Link"}
          </button>
          <p className="text-gray-400 text-sm text-center">
            <Link to={backTo} className="text-[#D4AF37]">Back to sign in</Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
